import ClientCard from './ClientCard.jsx';

export default ClientCard;